import {BivariateFrequencyTableFragment} from './fragments/bivariate-frequency-table-fragment';
import {CardResult, _CardResult} from './card-result';
import {Card} from './card';
import {_BivariateCard} from './bivariate-card';

/**
 * Generated from com.dataiku.dip.eda.worksheets.cards.Chi2IndTestCard
 */
export interface Chi2IndTestCard extends _BivariateCard {
    confidenceLevel: number;
    maxValuesX: number;
    maxValuesY: number;

    // PolyJson type
    type: 'chi2_independence_test';
}

export function isChi2IndTestCard(toTest: Card): toTest is Chi2IndTestCard { return 'chi2_independence_test' === toTest.type; }

export namespace Chi2IndTestCard {
    /**
     * Generated from com.dataiku.dip.eda.worksheets.cards.Chi2IndTestCard$Chi2IndTestCardResult
     */
    export interface Chi2IndTestCardResult extends _CardResult {
        dof: number;
        freqTableData: BivariateFrequencyTableFragment;
        pvalue: number;
        statistic: number;

        // PolyJson type
        type: 'chi2_independence_test';
    }

    export function isChi2IndTestCardResult(toTest: CardResult): toTest is Chi2IndTestCardResult { return 'chi2_independence_test' === toTest.type; }
}